import { useEffect } from "react";
import {
  applyDocumentSeo,
  canonicalHref,
  clearDocumentSeo,
  hreflangHrefs,
  stringifyJsonLd,
  type DocumentSeoHreflang,
} from "../utils/documentSeo";

export type UseDocumentSeoOptions = {
  description?: string | null;
  canonicalPath?: string | null;
  robots?: string;
  jsonLd?: unknown;
  hreflangDefault?: DocumentSeoHreflang | null;
};

export function useDocumentSeo({
  description,
  canonicalPath,
  robots,
  jsonLd,
  hreflangDefault,
}: UseDocumentSeoOptions): void {
  const jsonLdKey = jsonLd == null ? "" : stringifyJsonLd(jsonLd);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const origin = window.location.origin;
    applyDocumentSeo({
      description,
      canonicalHref:
        canonicalPath != null && canonicalPath !== ""
          ? canonicalHref(origin, canonicalPath)
          : null,
      robots,
      jsonLd: jsonLdKey ? (JSON.parse(jsonLdKey) as unknown) : undefined,
      hreflang:
        canonicalPath && hreflangDefault
          ? hreflangHrefs(origin, canonicalPath, hreflangDefault)
          : undefined,
    });
    return () => {
      clearDocumentSeo();
    };
  }, [description, canonicalPath, robots, jsonLdKey, hreflangDefault]);
}
